/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
export default {
  // 短信通道退订文案
  LZ_SMS_CANCEL_WORD: '拒收请回复R',
  // 当前用户信息在sessionStorage中缓存的key
  LZ_CRM_BIZ_USER: 'LZ_CRM_BIZ_USER',
}
